import InputsCreatorUniversal from "../../../../hooks/inputCreatorUniversal";

import innerStyles from "../../../../components/AdministrativeProcedures/commonComponents/universalInputComponent/universalInputComponent.module.css";
import styles from "./basicDataCertificate.module.css";

export default function BasicDataCertificate({
  fieldsOptions,
  inputData,
  register,
  newData,
  control,
  setValue,
  mode,
  errors,
  clearErrors,
  handleCustomButton,
  getValues,
  setError,
}) {
  return (
    <div
      className={
        inputData.licenseTypeId === 1
          ? styles[`block-data-container-republican`]
          : styles[`block-data-container-international`]
      }>
      <div className={styles["photo-container"]}>
        {/* <img
          src={photoImg}
          className="img-fluid"
          alt="main Photo"
        /> */}
        {(inputData?.fotoId && (
          <img
            src={`https://gims-dev.compit.by:8080/boats/file/download/attachment/${inputData?.fotoId.docid}`}
            className={styles["license-img"]}
            alt="Photo"></img>
        )) || <p className={styles["license-no-img"]}>{"Фото отсутствует"}</p>}
      </div>
      <h3 className={styles["caption-text"]}>Основные данные</h3>
      {Object.values(fieldsOptions).map((item) => {
        if (item.needInForm) {
          if (mode === "view") {
            return (
              <div className={`${styles["text-block"]} ${styles?.[`box-${item.key}`]}`}>
                <p className={styles["option-label"]}>{item.label}</p>
                <p className={styles["option-value"]}>
                  {item.type === "selectWithSearch"
                    ? item.options.find((elem) => elem.value === inputData?.[item.key])?.label || "—"
                    : item.type === "date" && inputData?.[item.key]
                    ? inputData?.[item.key].split("-").reverse().join(".")
                    : inputData?.[item.key] || "—"}
                </p>
              </div>
            );
          } else {
            return (
              <InputsCreatorUniversal
                option={item}
                styles={innerStyles}
                register={register}
                newData={newData}
                control={control}
                setValue={setValue}
                mode={mode}
                errors={errors}
                clearErrors={clearErrors}
                handleCustomButton={handleCustomButton}
                getValues={getValues}
                setError={setError}
              />
            );
          }
        }
      })}
    </div>
  );
}
